import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  type AccordionProps,
  type AccordionSummaryProps,
  type AccordionDetailsProps,
} from '@mui/material'
import { styled } from '@mui/material/styles'

import React from 'react'

const StyledAccordion = styled(Accordion)(({ theme }) => {
  const radius = theme.shape.borderRadius * 4
  const border = `1px solid ${theme.palette.background.border}`

  return {
    borderRadius: radius,
    '&:before': { display: 'none' },
    backgroundColor: theme.palette.background.subtle,
    border: border,
    boxShadow: 'none',
    transition: 'box-shadow 0.2s ease-in-out',
    '&:first-of-type': {
      borderRadius: radius,
    },
    '&:last-of-type': {
      borderRadius: radius,
    },
    '&:last-child': {
      borderRadius: radius,
      '&:not(.Mui-expanded)': {
        borderRadius: radius,
      },
      '&.Mui-expanded': {
        borderRadius: radius,
      },
    },
  }
})

const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => {
  const radius = theme.shape.borderRadius * 4
  const border = `1px solid ${theme.palette.background.border}`

  return {
    // borderRadius: radius,
    '.MuiAccordionSummary-content': { margin: 0 },
    '&.Mui-expanded': {
      borderBottom: 'none',
      borderBottomRightRadius: 0,
      borderBottomLeftRadius: 0,
    },
    '&.Mui-expanded + .MuiCollapse-root .MuiAccordionDetails-root': {
      borderTop: border,
    },
  }
})

const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => {
  const border = `1px solid ${theme.palette.background.border}`

  return {
    borderTop: border,
    padding: 8,
  }
})

type SidebarAccordionProps = {
  label: React.ReactNode
  children: React.ReactNode
  expandIcon?: React.ReactNode
  summaryProps?: AccordionSummaryProps
  detailsProps?: AccordionDetailsProps
} & Omit<AccordionProps, 'children'>

const SidebarAccordion: React.FC<SidebarAccordionProps> = ({
  label,
  children,
  expandIcon = <ExpandMoreIcon />,
  summaryProps,
  detailsProps,
  ...accordionProps
}) => {
  return (
    <StyledAccordion elevation={0} {...accordionProps}>
      <StyledAccordionSummary expandIcon={expandIcon} {...summaryProps}>
        {typeof label === 'string' ? <Typography component="span">{label}</Typography> : label}
      </StyledAccordionSummary>
      <StyledAccordionDetails {...detailsProps}>{children}</StyledAccordionDetails>
    </StyledAccordion>
  )
}

export default SidebarAccordion
